import type { CustomLinkFormData } from "./QuickLinkDefs";

export function isCustomLinkValid(
  customLink: CustomLinkFormData | undefined
): boolean {
  if (!customLink) {
    return false;
  }
  if (customLink.translations.length === 0) {
    return false;
  }
  return customLink.translations.every(
    (tr) => tr.name.trim() !== "" && tr.url.trim() !== ""
  );
}
